import { createAction, props } from '@ngrx/store';
import { BreadcrumbItem } from '../reducer/breadcrumb.reducer';

export enum BreadcrumbActionTypes {
    AppendBreadcrumb = '[Breadcrumb] Append Breadcrumb',
    AppendBreadcrumbs = '[Breadcrumb] Append Breadcrumbs',
    ActivateBreadcrumb = '[Breadcrumb] Activate Breadcrumb',
    GoBack = '[Breadcrumb] Go Back'
}

export const AppendBreadcrumb = createAction(BreadcrumbActionTypes.AppendBreadcrumb, props<{ breadcrumb: BreadcrumbItem }>());
export const AppendBreadcrumbs = createAction(BreadcrumbActionTypes.AppendBreadcrumbs, props<{ breadcrumbs: BreadcrumbItem[] }>());
export const ActivateBreadcrumb = createAction(
    BreadcrumbActionTypes.ActivateBreadcrumb,
    props<{ breadcrumb: BreadcrumbItem; currentRoute: string }>()
);
export const GoBack = createAction(BreadcrumbActionTypes.GoBack);
